import appSettings from "apps/services/config"
import React from "react"

export const saleDashBoard = () =>{
    return(
        <>
       <iframe
        src={appSettings.dashboard_url+'/saleDashboard'}
        title="Example Iframe"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        
        ></iframe>
       </>
    )
}
export default saleDashBoard